import React from 'react';
import { Chip, ChipProps } from '@heroui/react';
import { cn } from '@/shared/lib/utils';

export interface BadgeProps extends Omit<ChipProps, 'color' | 'variant'> {
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'primary' | 'secondary';
  icon?: React.ReactNode;
}

const getHeroUIColor = (variant: BadgeProps['variant']) => {
  switch (variant) {
    case 'success':
      return 'success' as const;
    case 'warning':
      return 'warning' as const;
    case 'danger':
      return 'danger' as const;
    case 'primary':
      return 'primary' as const;
    case 'secondary':
      return 'secondary' as const;
    case 'default':
    default:
      return 'default' as const;
  }
};

export const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant = 'default', icon, children, ...props }, ref) => {
    const color = getHeroUIColor(variant);
    
    return (
      <Chip
        ref={ref}
        color={color}
        variant="flat"
        size="sm"
        startContent={icon}
        className={cn(className)}
        {...props}
      >
        {children}
      </Chip>
    );
  }
);

Badge.displayName = 'Badge';